import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { createAppTheme } from './theme';

const theme = createAppTheme();

/**
 * App theme provider.
 * Dark mode is disabled for now: `storageManager={null}` stops MUI from reading a
 * persisted (or system) preference, so the app is always locked to light. The dark
 * scheme plumbing in `theme.js` is retained for when we revisit it — drop the
 * `storageManager` prop to re-enable user-selectable modes.
 */
export const ThemeProvider = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme} defaultMode="light" storageManager={null} disableTransitionOnChange>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
